/**
 * Vehicle damage fault values
 */
export enum VehicleDamageFaultEnum {
	DRIVER = 'driver',
	THIRD_PARTY = 'third_party',
	SHARED = 'shared',
	VEHICLE_MALFUNCTION = 'vehicle_malfunction',
	ENVIRONMENTAL = 'environmental',
	UNKNOWN = 'unknown',
}
